<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
       version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 13883 13883"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="13883" height="13883" rx="1354" ry="1354" />
   <rect class="fil1" x="2550" y="4168" width="6899" height="4599" />
   <g id="_725589456">
   <circle class="fil1 str0" cx="11726" cy="9312" r="348" />
     <circle class="fil1 str0" cx="11726" cy="6941" r="348" />
     <circle class="fil1 str0" cx="11726" cy="4571" r="348" />
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'Regulator',
};
</script>

<style scoped>
.str0 {
  stroke: #FEFEFE;
  stroke-width: 395.065
}

.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
